import { render, staticRenderFns } from "./JsonArgument.vue?vue&type=template&id=524aad36&scoped=true&"
import script from "./JsonArgument.vue?vue&type=script&lang=ts&"
export * from "./JsonArgument.vue?vue&type=script&lang=ts&"
import style0 from "./JsonArgument.vue?vue&type=style&index=0&id=524aad36&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524aad36",
  null
  
)

export default component.exports